import { useMemo } from 'react'

import { createAppTheme, PALETTE_SCOPES } from '../../styles/material-ui/create-app-theme'
import { useColorMode } from '../../hooks/color-mode.hooks'
import useSiteStore from '../../stores/site.store'

// Demo public routes should always use brand palette regardless of site context
const DEMO_BRAND_PATHS = ['/signup', '/verify', '/creating', '/magic-link', '/login']
const isDemoBrandRoute = () => {
  const hostname = window.location.hostname
  const isDemoHost =
    hostname.split('.')[0] === 'demo' ||
    ((hostname === 'localhost' || hostname === '127.0.0.1') &&
      import.meta.env.VITE_DEMO_STAFF_TENANT_ID)
  if (!isDemoHost) {
    return false
  }
  return DEMO_BRAND_PATHS.some(
    (p) => window.location.pathname === p || window.location.pathname.startsWith(p + '/')
  )
}

export const useAppTheme = () => {
  const { currentSite } = useSiteStore()
  const mode = useColorMode()

  return useMemo(() => {
    const isLocationContext = !!currentSite && !isDemoBrandRoute()
    const scope = isLocationContext ? PALETTE_SCOPES.location : PALETTE_SCOPES.brand
    return createAppTheme({ mode, scope })
  }, [currentSite, mode])
}
